import { render, staticRenderFns } from "./PublicOrganizeTableForm.vue?vue&type=template&id=30ab815c&scoped=true"
import script from "./PublicOrganizeTableForm.vue?vue&type=script&lang=js"
export * from "./PublicOrganizeTableForm.vue?vue&type=script&lang=js"
import style0 from "./PublicOrganizeTableForm.vue?vue&type=style&index=0&id=30ab815c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ab815c",
  null
  
)

export default component.exports